module.exports = __webpack_public_path__ + "static/media/scythe.00cdd5fd.svg";